module.exports = __webpack_public_path__ + "img/warehouse.b3fda8ef.svg";